export default __webpack_public_path__ + "static/media/640_business04-fr-web.5afd856d.png";